import * as cn from "./ActivityLog.scss"

import * as React from "react"
import {findDOMNode} from "react-dom"
import {List} from "./List"
import {parseResult, Log, SortType, SortDirection, sort, Result} from "./parseResult"
import {exportXlsx} from "./exportXlsx"
import {logger} from "../utils/logger";

interface PartialState {
    log?: Log
    lastViewed?: Date
    active?: boolean
    rendered?: boolean
    sortType?: SortType
    sortDirection?: SortDirection
}

interface State extends PartialState {
    lastViewed: Date
    active: boolean
    rendered: boolean
    sortType: SortType
    sortDirection: SortDirection
}

export class ActivityLog extends React.PureComponent<{}, PartialState> {
//    debugRenderPerformance = true
//    displayName = __filename
    list: Element | null;

    state: State = {
        lastViewed: new Date(),
        active: false,
        rendered: false,
        sortType: SortType.Date,
        sortDirection: SortDirection.Asc,
    }

    fetchInterval: number

    componentDidMount() {
//        this.fetch()
        document.addEventListener("activitylog:open", this.open)
    }

    componentWillUnmount() {
        clearInterval(this.fetchInterval)
        document.removeEventListener("activitylog:open", this.open)
    }

    open = () => {
        this.setState({active: true, rendered: true})
        this.fetch()

        this.fetchInterval = window.setInterval(this.fetch, 30000)

        if (this.state.log && (this.state.sortType === SortType.Date) && (this.state.sortDirection === SortDirection.Asc)) {
            const list = findDOMNode(this.list)
            if (list) {
                (list as Element).scrollTop = (list as Element).scrollHeight
            }
        }
    }

    close = () => {
        clearInterval(this.fetchInterval)
        this.setState({active: false})
    }

    toggleSort = (type: SortType) => {
        const {
            sortType,
            sortDirection,
        } = this.state

        this.setState({
            sortType: type,
            sortDirection: (type !== sortType) ? SortDirection.Asc : ((sortDirection === SortDirection.Asc) ? SortDirection.Desc : SortDirection.Asc)
        })
    }

    toggleSortDirection = () => this.setState({
        sortDirection: (this.state.sortDirection === SortDirection.Asc) ? SortDirection.Desc : SortDirection.Asc
    })

    fetch = () => {
        const {
            log,
        } = this.state

        fetch("/activity-log", {credentials: "include"})
            .then(response => response.json())
            .then<Result>(response => response as any)
            .then(result => this.setState({log: parseResult(result, log)}))
            .catch(error => logger.captureException(error))
    }

    export = () => {
        const {
            log,
            sortType: type,
            sortDirection: direction,
        } = this.state

        try {
            if (log === undefined) {
                throw new Error(`Log is being exported before fetch`)
            }
        } catch (e) {
            logger.captureException(e)

            return
        }

        exportXlsx(sort(log, {type, direction}))
    }

    render() {
        const {
            log,
            active,
            rendered,
            sortType: type,
            sortDirection: direction,
        } = this.state

        return rendered ? (
            <div className = {cn.component + (active ? " " + cn.active : "")}>
                <div className = {cn.menu}>
                    <a href = "#" className = {cn.close} onClick = {ev => {
                        ev.preventDefault()
                        this.toggleSort(SortType.Date)
                    }}>
                        <i className = "fa fa-calendar"/>
                    </a>
                    <a href = "#" className = {cn.close} onClick = {ev => {
                        ev.preventDefault()
                        this.toggleSort(SortType.From)
                    }}>
                        <i className = "fa fa-user"/>
                    </a>
                    <a href = "#" className = {cn.close} onClick = {ev => {
                        ev.preventDefault()
                        this.toggleSort(SortType.Message)
                    }}>
                        <i className = "fa fa-comment-o"/>
                    </a>
                    <a href = "#" className = {cn.close} onClick = {ev => {
                        ev.preventDefault()
                        this.toggleSortDirection()
                    }}>
                        <i className = {`fa ${direction === SortDirection.Desc ? "fa-sort-desc" : "fa-sort-asc"}`}/>
                    </a>
                    <a href = "#" className = {cn.close} onClick = {ev => {
                        ev.preventDefault()
                        this.export()
                    }}>
                        <i className = "fa fa-file-excel-o"/>
                    </a>
                    <span className = {cn.divider}/>
                    <a href = "#" className = {cn.close} onClick = {ev => {
                        ev.preventDefault()
                        this.close()
                    }}>
                        <i className = "fa fa-times"/>
                    </a>
                </div>
                {!log ? (
                    <span className = {cn.spinner}>
                        <i className = "fa fa-circle-o-notch fa-spin fa-2x fa-fw"/>
                    </span>
                ) : (
                    <div ref={list=>this.list = list} className = {cn.list}>
                        <List {...{log: sort(log, {type, direction})}}/>
                    </div>
                )}
            </div>
        ) : <span/>
    }
}